"use strict";
angular.module("editTrackModule", [])
    .controller("editTrackCtrl", ['$scope', '$q', '$state', '$modalInstance', 'trackId', '$filter', '$validation', 'modalDialog', 'trsspliceString', 'trsHttpService',
        function($scope, $q, $state, $modalInstance, trackId, $filter, $validation, modalDialog, trsspliceString, trsHttpService) {
            initStatus();
            initData();
            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    trackId: trackId ? trackId : 0,
                    title: trackId ? '编辑监测跟踪' : '新建监测跟踪'
                }
                $scope.data = {
                    trackData: {},
                    allKeywords: [],
                    anyKeywords: [],
                    noneKeywords: []
                }
            }
            /**
             * [initData description] 数据初始化
             * @return {[type]} [description]
             */
            function initData() {
                ($scope.status.trackId == 0 ? initNewData() : initEditData()).then(() => {});
            }
            /**
             * [initNewData description] 获取新建数据
             * @return {[type]} [description]
             */
            function initNewData() {
                let defer = $q.defer();
                $scope.data.trackData = {
                    title: '',
                    includeall: '',
                    includeany: '',
                    includenone: '',
                }
                defer.resolve();
                return defer.promise;
            }
            /**
             * [initEditData description] 获取监测跟踪数据
             * @return {[type]} [description]
             */
            function initEditData() {
                let defer = $q.defer();
                let params = {
                    id: $scope.status.trackId,
                    serviceid: 'monitortrack',
                    modelid: 'getTrackInfo'
                }
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                    $scope.data.trackData = {
                        title: data.TITLE,
                        includeall: data.INCLUDEALL,
                        includeany: data.INCLUDEANY,
                        includenone: data.INCLUDENONE,
                        id: data.ID
                    };
                    $scope.data.startTime = data.START;
                    $scope.data.endTime = data.END;
                    $scope.data.allKeywords = data.INCLUDEALL == '' ? [] : data.INCLUDEALL.split(';');
                    $scope.data.anyKeywords = data.INCLUDEANY == '' ? [] : data.INCLUDEANY.split(';');
                    $scope.data.noneKeywords = data.INCLUDENONE == '' ? [] : data.INCLUDENONE.split(';');
                    defer.resolve();
                });
                return defer.promise;
            }
            /**
             * [cancel description] 关闭弹窗
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                    $modalInstance.dismiss();
                }
                /**
                 * [confirm description] 保存
                 * @return {[type]} [description]
                 */
            $scope.confirm = function() {
                $validation.validate($scope.trackForm).success(function() {
                    if ((!!$scope.data.endTime) &&
                        new Date(new Date($scope.data.startTime).toLocaleDateString()) > new Date(new Date($scope.data.endTime).toLocaleDateString())) {
                        modalDialog.alertType('', '开始时间不得大于结束时间', 'error', false);
                        return;
                    }
                    $scope.data.trackData.includeall = trsspliceString.spliceString($scope.data.allKeywords, "name", ";");
                    $scope.data.trackData.includeany = trsspliceString.spliceString($scope.data.anyKeywords, "name", ";");
                    $scope.data.trackData.includenone = trsspliceString.spliceString($scope.data.noneKeywords, "name", ";");
                    $scope.data.trackData.search_date = angular.isUndefined($scope.data.endTime) ? $filter("date")($scope.data.startTime, "yyyy-MM-dd") + ';' : $filter("date")($scope.data.startTime, "yyyy-MM-dd") + ';' + $filter("date")($scope.data.endTime, "yyyy-MM-dd");
                    let params = $scope.data.trackData;
                    params.serviceid = 'monitortrack';
                    params.modelid = 'saveConfig';
                    trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('', $scope.status.trackId ? '编辑成功' : '新建成功', 'success', false);
                        $modalInstance.close();
                    });
                }).error(function() {
                    modalDialog.alertType('', '请检查必填项', 'error', false);
                });
            }
        }
    ]);